import React from "react";
import { QUERY_STOCK_ORDERS } from "../../../../utils";
import { useLoadMoreList } from "../../../../../../utilities/load-more-list";
import { StockOrder } from "@towersystems/roam-common/lib/generated-types";
import { useScheduler } from "../../../../../../utilities/scheduler";
import { useSearchQueryProvider } from "../../../../../../utilities/search";
import { FlatListSearchableSkeleton } from "../../../../../../components/FlatListSearchableSkeleton";
import { useFocusEffect } from "@react-navigation/native";
import { StockOrderResourceList } from "../../../../components/StockOrderResourceList";
import { isInt } from "../../../../../../utilities/is-int";
import { filterValuesToApiInput } from "../../common";
import { useListFilterContext } from "../../../../../../utilities/list-filter/use-list-filter-context";
import { StockOrderFilterValues } from "../../../../types";

export interface PendingStockOrdersListProps {}

export const PendingStockOrdersList = ({}: PendingStockOrdersListProps) => {
  const search = useSearchQueryProvider();
  const { schedule } = useScheduler(500);

  const { watch } = useListFilterContext<StockOrderFilterValues>();
  const watchedFilterValues = watch();

  const loadMoreList = useLoadMoreList<StockOrder>({
    initialLoad: false,
    query: QUERY_STOCK_ORDERS,
    resultKey: "stockOrders",
    sort: { updatedAt: "DESC" },
    variableFormatter: (variables) => {
      return {
        options: {
          ...variables,
          filter: {
            ...variables.filter,
            status: { eq: "PENDING" },
          },
        },
      };
    },
  });

  useFocusEffect(
    React.useCallback(() => {
      handleLoadMore(true);
    }, [watchedFilterValues])
  );

  React.useEffect(() => {
    if (loadMoreList.called) {
      schedule(() => {
        handleLoadMore(true);
      });
    }
  }, [search.query]);

  const handleLoadMore = (reset?: boolean) => {
    loadMoreList.loadMore(
      {
        filter: {
          orderNumber: {
            eq: search.query
              ? isInt(search.query)
                ? parseInt(search.query)
                : 9999999
              : undefined,
          },
          ...filterValuesToApiInput(watchedFilterValues),
        },
      },
      reset
    );
  };

  const items: StockOrder[] = loadMoreList.items || [];

  if (loadMoreList.loading && loadMoreList.items.length == 0) {
    return <FlatListSearchableSkeleton searchbar={false} />;
  }

  return (
    <StockOrderResourceList
      items={items}
      onEndReached={() => handleLoadMore(false)}
    />
  );
};
